import React, { Component, PropTypes } from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import HjblcxTable from './hjblcxTable';
import Import from './import/index';
import {hasAuth} from '../../../utils/NHCore';
import NHTable from "../../common/NHTable";

const baseUrlPath = "/tjcx/hjblcx"; //基础路径


/**
 * hjblcx列表
 * @author Xiafanglin
 * @date 2018-03-20 09:56:14
 * Version: 1.0
 */
export default class HjblcxTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns:[],
        }
    }
    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                search: 'input',
                width: '150px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                search: 'input',
                width: '90px',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            },{
                title: '校区',
                width: '200px',
                dataIndex: 'XQMC',
                searchType:"select"
            },{
                title: '院系',
                width: '200px',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            },{
                title: '专业',
                width: '200px',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            },{
                title: '班级',
                width: '200px',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }
        ];
        this.setState({
            selectKey: this.props.selectKey,
            columns:columnConst,
        },() => {
            this.getColumn(this.state.selectKey);
        });
    }
    //获取动态字段
    getColumn = (lcdyid) => {
        if (lcdyid) {
            NHFetch(baseUrlPath+"/getHjdyData","get","lcid="+lcdyid).then(
                res => {
                    if (res.data) {
                        let columnLet = this.state.columns;
                        res.data.map((item) => {
                            let column = {
                                title: item.HJMC,
                                width: '200px',
                                search: 'input',
                                filters: [{ text: '已办理', value: '已办理' }, { text: '未办理', value: '未办理' }],
                                dataIndex: "a"+item.BZ,
                                searchType:"select",
                                sign:"DMK_YXXT_SFBL",
                            };
                            columnLet.push(column);
                        });
                        this.setState({
                            columns: columnLet
                        });
                    }
                }
            )
        }

    }

    //导入点击事件
    handleInputZyzxx = () =>{
        this.refs.nhExcel.show();
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('环节办理信息');
    }

    //环节办理信息导入
    handleSaveHjblxx =(resultObj) =>{
        console.log(resultObj)
        if (resultObj && resultObj.length>0){
            NHFetch(baseUrlPath+'/inputHjblxx','POST',{uuid:resultObj}).then(res =>{
                if (res && res.data){
                    let{successResult,resetResult,failResult,failMsg} = res.data;
                    if((successResult>0 || resetResult>0) && failResult == 0){
                        let msg ='';
                        if(successResult>0){
                            msg +=("新增导入"+successResult+"条数据");
                        }
                        if (resetResult>0){
                            msg +=("覆盖导入"+resetResult+"条数据");
                        }
                        message.success(msg);
                        this.refs.nhTable.filterTableData();
                        this.refs.nhExcel.close();
                    }else {
                        this.refs.nhExcel.close();
                        Modal.warning({
                            title:"提示",
                            width:500,
                            content:<div>
                                {successResult > 0 ? <div>新增导入<font color={'blue'}>{successResult}</font>条数据。</div> : null}
                                {resetResult > 0 ? <div>覆盖导入<font color={'blue'}>{resetResult}</font>条数据。</div> : null}
                                {failResult > 0 ? <div>导入失败<font color={'red'}>{failResult}</font>条数据。</div> : null}
                                <div style={{ paddingLeft: 10, marginTop: 10, maxHeight: 150, overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: failMsg }} />
                            </div>
                        })
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
        }
        else{
            message.warning("导入数据不能为空！");
            this.refs.nhExcel.closeSpin();
        }
    }

    render() {
        return(
            <div className={css.main_right_content} style={{height:getSize().windowH-230}}>
                <div className={css.table} >
                    <HjblcxTable ref='nhTable'
                             rowKey={record =>record.XH} //TODO 把此处的信息改成自己的
                             columns={this.state.columns}
                             sign={this.props.selectKey}
                             initParams={this.props.initParams}
                             rangeFilter={true}
                    >
                        {hasAuth('zhxg_yxgl_tjcx_hjblcx:import')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.handleInputZyzxx}>导入</Button>:undefined}
                        {hasAuth('zhxg_yxgl_tjcx_hjblcx:export')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.handleOtpBtnClick}>导出</Button>:undefined}
                    </HjblcxTable>
                </div>
                <Import ref='nhExcel' tempStr={'环节办理信息采集模板.xlsx'} title={'环节办理信息采集数据导入'}
                        data={{ 录取号: 'lqh',考生号:'ksh', 身份证件号: 'sfzjh',学号:'xh',准考证号:'zkzh',环节名称:'hjmc'}}
                        width={600}
                        onOk={this.handleSaveHjblxx}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/hjblcxTab.js